// import useragent from "useragent";
import { MsalAuthProvider, LoginType } from "react-aad-msal";
import { AuthenticationParameters } from "msal";
import { AUTH_CONFIG } from "./config";

// Authentication Parameters
export const authenticationParameters: AuthenticationParameters = {
  scopes: ["openid", "profile", "User.Read", "User.Read.All", "GroupMember.Read.All"],
};

// Options
const options = {
  // Use Popup login type for Safari
  // Known issue: https://github.com/syncweek-react-aad/react-aad/issues/188 ,
  // root cause: https://github.com/AzureAD/microsoft-authentication-library-for-js/issues/1205
  // loginType: useragent.is(navigator.userAgent).safari ? LoginType.Popup : LoginType.Redirect,
  loginType: LoginType.Redirect,
  // When a token is refreshed it will be done by loading a page in an iframe.
  // Rather than reloading the same page, we can point to an empty html file which will prevent
  // site resources from being loaded twice.
  // tokenRefreshUri: window.location.origin + "/auth.html",
  //tokenRefreshUri: process.env.REACT_APP_AUTH_REDIRECT_URL + "/auth.html",
};

export const authProvider = new MsalAuthProvider(AUTH_CONFIG, authenticationParameters, options);
